import { User_userPermissions } from "@saleor/fragments/types/User";
import useUser from "@saleor/hooks/useUser";
import { PermissionEnum, SmopUserTypeCode } from "@saleor/types/globalTypes";

export const canManageFulfillment = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission => permission.code === PermissionEnum.MANAGE_ORDERS
    )
  );
};

export const canManageStoreOrders = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission => permission.code === PermissionEnum.MANAGE_STORE_ORDERS
    )
  );
};

export const canManageDropOff = (): boolean => {
  const user = useUser();
  const permissions = user?.user?.userPermissions || [];

  return (
    permissions.some(
      permission => permission.code === PermissionEnum.MANAGE_HOME_LOCATIONS
    ) &&
    permissions.some(
      permission => permission.code === PermissionEnum.MANAGE_TASK_AREAS
    )
  );
};

export const canViewAllMalls = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission => permission.code === PermissionEnum.VIEW_ALL_MALLS
    )
  );
};

export const canManageAllMalls = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission => permission.code === PermissionEnum.MANAGE_ALL_MALLS
    )
  );
};

export const canViewMasterFulfillment = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission => permission.code === PermissionEnum.VIEW_MASTER_FULFILLMENT
    )
  );
};

export const isUserWithMallAssignment = (): boolean => {
  const user = useUser();
  return Boolean(
    [
      SmopUserTypeCode.OMI_OPS,
      SmopUserTypeCode.STORE_ADMIN,
      SmopUserTypeCode.RUNNER
    ].includes(user?.user?.userType?.code)
  );
};

export const canManageRemittance = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission => permission.code === PermissionEnum.MANAGE_REMITTANCE
    )
  );
};

export const canManageOverrideRemittance = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission =>
        permission.code === PermissionEnum.MANAGE_REMITTANCE_OVERRIDE
    )
  );
};

export const canOverrideNonLegacyCourier = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission =>
        permission.code ===
        PermissionEnum.MANAGE_REMITTANCE_OVERRIDE_NON_LEGACY_COURIER
    )
  );
};

export const canManageMalls = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission => permission.code === PermissionEnum.MANAGE_MALLS
    )
  );
};

export const checkUserPermissionsCanAccessMalls = (
  userPermissions: User_userPermissions[]
): boolean =>
  Boolean(
    userPermissions.some(
      permission =>
        permission.code === PermissionEnum.MANAGE_MALLS ||
        permission.code === PermissionEnum.MODIFY_MALLS
    )
  );

export const canManageTenants = (): boolean => {
  const user = useUser();
  return Boolean(
    user?.user?.userPermissions.some(
      permission => permission.code === PermissionEnum.MANAGE_TENANTS
    )
  );
};

export const checkUserPermissionsCanAccessTenants = (
  userPermissions: User_userPermissions[]
): boolean =>
  Boolean(
    userPermissions.some(
      permission =>
        permission.code === PermissionEnum.MANAGE_TENANTS ||
        permission.code === PermissionEnum.MODIFY_TENANTS
    )
  );
